// @flow
import classnames from 'classnames';
import React, { useState } from 'react';

import useInterval from '../../../hooks/useInterval';

import CheckmarkIcon from '../../../components/Icons/Checkmark';

import type { Notification } from '../../../types/cc-mode';

import useStyles from './NotificationContainer.styles';

interface Props {
  notifications: Notification[];
}

const NotificationContainer = ({ notifications }: Props) => {
  const classes = useStyles();

  const latestNotification = notifications[notifications.length - 1];
  const [currentTimestamp, setCurrentTimestamp] = useState(Date.now());

  useInterval(() => {
    setCurrentTimestamp(Date.now());
  }, 1000);

  // Don't display a notification if it does not exist or is >= 3 seconds old.
  if (!latestNotification || currentTimestamp - 3000 >= latestNotification.timestamp) {
    return null;
  }

  return (
    <div className={classes.root}>
      <span className={classnames(classes.text, { [classes.successText]: latestNotification.type === 'success' })}>
        {latestNotification.text}
      </span>
      {latestNotification.type === 'success' && <CheckmarkIcon width={16} height={16} />}
    </div>
  );
};

export default NotificationContainer;
